export default __webpack_public_path__ + "static/media/Medium Gas Grenade.07db2bca.PNG";